import React from 'react';
import { useSelector } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { getLocale } from '../selectors/router';

const Provider = ({ messages, children }) => {
  const localeId = useSelector(getLocale);

  return (
    <IntlProvider
      locale={localeId}
      key={localeId}
      messages={messages[localeId]}
    >
      {children}
    </IntlProvider>
  );
};

export default Provider;
